// Shared display formatters (PT-PT).

// "2026-02-10" or full ISO -> "10/02/2026"
export function formatDatePT(iso) {
  if (!iso) return "";
  const d = String(iso).slice(0, 10);
  const parts = d.split("-");
  if (parts.length === 3) return `${parts[2]}/${parts[1]}/${parts[0]}`;
  return d;
}

// True when end time is earlier than start time (event runs past midnight).
export function isOvernight(start, end) {
  if (!start || !end) return false;
  try {
    const [sh, sm] = String(start).split(":").map(Number);
    const [eh, em] = String(end).split(":").map(Number);
    return eh * 60 + em < sh * 60 + sm;
  } catch {
    return false;
  }
}

// 24h range display with an overnight hint. "22:00–02:00 (+1 dia)"
export function formatTimeRange(start, end) {
  if (start && end) return `${start}–${end}${isOvernight(start, end) ? " (+1 dia)" : ""}`;
  return start || "";
}
